import { Moment } from "moment";
import { durationToWeeksM } from "@bonliva-crm/common";

export class SelectionState {
  start!: Moment;
  end!: Moment;
  selectedWeeks!: Date[];
  type!: "add" | "subtract";

  static create(type: "add" | "subtract", start: Moment, end: Moment) {
    const state = new SelectionState();
    state.start = start;
    state.end = end;
    state.type = type;
    state.selectedWeeks = durationToWeeksM(start, end);

    if (state.start > state.end) {
      const tmp = state.start;
      state.start = state.end;
      state.end = tmp;
    }

    return state;
  }
}
